import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PageEvent as PageEvent } from '@angular/material/paginator';
import { ApiService } from 'src/app/api/api.service';
import { LoaderService } from 'src/app/api/loader.service';
import { IamService } from 'src/app/services/iam.service';
import { MeService } from 'src/app/services/me.service';
import { UserService } from 'src/app/services/user.service';
import { MessageService } from 'primeng/api';
@Component({
    selector: 'app-temporal-transactions',
    templateUrl: './temporal-transactions.component.html',
    styleUrls: ['./temporal-transactions.component.css'],
    providers: [MessageService],
    standalone: false
})
export class TemporalTransactionsComponent implements OnInit {

  pageEvent: PageEvent;
  iAm:any;
  ucontact_did = null;
  auth_token = null;
  temporalTransactions;
  channels:any;
  typologies:any; 
  showDialogFilter:boolean;
  showDetail: boolean;
  showTable:boolean;
  showCreate: boolean;
  filter:any;
  filter2:any;
  page:number;
  totalTransactions:number;
  perPage:number;
  crmUsers:any;
  stopLightNumber:number;
  //pageEvent: PageEvent;
  ticket: any;
  showCloseTicketForm:boolean;
  selectedTransaction:any;
  closeTransactionComment:any;

  constructor(private loaderService: LoaderService,
              private api: ApiService, 
              private router: Router, 
              private me: MeService,
              private activatedRoute: ActivatedRoute,
              //private gs: GlobalService,
              private userService: UserService,
              private iam: IamService,
              public messageService: MessageService
             ){ 
              this.iAm = this.iam.isRole;
              //this.ucontact_did = this.gs.id;d
              this.auth_token = null;
              this.temporalTransactions = [];
              this.channels = {
                1:'Telemercadeo',
                2:'Sucursales',
                3:'Digital',
                4:'Otro',
              }
              this.typologies = [];
              this.showDialogFilter = false;
              // this.filter = {
              //   status: 1,
              //   id: null,      
              // };
              this.filter = {};
              this.filter2 = {};
              this.page = 1;
              this.totalTransactions = 0;
              this.perPage = 8;
              this.crmUsers = [];
             // this.crmUsers = [{name:'Juan Jośe Hernández',email:'jjhernandez@grupoasys.com'}]
              this.stopLightNumber = 0;
              this.ticket = undefined;
              this.showCloseTicketForm = false;
              this.showDetail = false;
              this.selectedTransaction = {
                country_id: 0,
                transaction_number: "GTI-0",
                priority: 10,
                subtypology_id: 0,
                username: "",
                creation_date: "",
                sponsor_id: "",
                typology_id: 0,
                v_status: 10,
                id: 0,
                user_id: 0,
                payload: {
                    name: "",
                    channel: "",
                    policy_number: "",
                    product: "",
                    notes: "",
                    ammount: "",
                    country_id: "",
                    create_date: "",
                    typology_id: "",
                    transaction_date: "",
                    transaction: "",
                    dni: "",
                    subtypology_id: "",
                    sponsor: "",
                    tran_type: "",
                    transaction_type: "",
                    priority: 10,
                    phone: "",
                    sponsor_id: "",
                    country: ""
                },
              };
              this.closeTransactionComment = "";
             }

  ngOnInit(): void {
    this.resetFilter()
    this.showTable=true;
    this.loadTransactionsinit()
    this.loadusers();
    
  }
  async loadTransactions(){
    this.loaderService.display(true);
  
    //await this.loadParams();
    await this.loadtemporalTransactions(); 
   // await this.loadCrmUsers();
   // await this.loadTypologies();
    //await this._loaddescriptions();
    this.loaderService.display(false);
  }

  async loadTransactionsinit(){
    this.loaderService.display(true);
  
    //await this.loadParams();
    await this.loadtemporalTransactions(); 
   // await this.loadCrmUsers();
   // await this.loadTypologies();
    //await this._loaddescriptions();
    await this.loadCrmUsers();
    this.loaderService.display(false);
  }
  
  async loadusers(){
    this.loaderService.display(true);
    await this.loadCrmUsers();
    this.loaderService.display(false);
  }

  async loadtemporalTransactions(){
    let params = {
      "token": this.auth_token,
      "transaction": 'get_temporal_transaction',
      "page": this.page,
      "per_page":this.perPage
    }
    await this.api.temporal_transaction_k2.get(params).filter(this.filter).promise().then(data =>{
      //
      if(data.total){this.totalTransactions = data.total}
      this.temporalTransactions = data.data.map(t =>{
        let d = new Date(t.creation_date);
        t.creation_date = this.dateFormat(d)
        if(t.close_date){
          let d2 = new Date(t.creation_date);
          t.close_date = this.dateFormat(d2)
        }
        return t
      }); 
    //  
    }).catch(e => {
     // 
      if(e.status === 401){
        this.router.navigate(['/']);
      }
    });
        
  }
  async loadParams(){
    // if (this.me.getToken()) {
    //   this.auth_token = this.me.getToken();
    // }
    // this.activatedRoute.queryParams.subscribe(params => {
    //   if ("token" in params) {
    //     this.auth_token = params["token"]
        
    //   }
    // });
  }
  async loadTypologies(){
    let _params = {
      "token": this.auth_token
    }
    await this.api.temporalTransactions.typologies().get().promise().then(data => {
      this.typologies = data.data.filter(t => t.value_ == 'crm_typology' || t.value_ == 'crm_utils_temporal_transactions');
      let arreglo = [];
      this.typologies = this.typologies.map(t=>{
        arreglo = arreglo.concat(t.typologies);
      });
      this.typologies = arreglo;
    })
    .catch(e => {
      
    })
  }
  async _loaddescriptions(){
    let typo = this.typologies.find(t => t.id === this.selectedTransaction.typology_id);
    let tran = this.typologies.find(tr => tr.id == this.selectedTransaction.payload.tran_type);
    if(tran != undefined){
      this.selectedTransaction.tran_typeDesc = tran.description;
    }
    if(typo != undefined){
      this.selectedTransaction.typologyDesc = typo.description;

      if(this.selectedTransaction.subtypology_id == 0){
        this.selectedTransaction.subtypologyDesc = this.selectedTransaction.typologyDesc;
      }
      else{
        let subty = typo.subtypologies.find(st => st.id === this.selectedTransaction.subtypology_id);  
        if(subty != undefined){
          this.selectedTransaction.subtypologyDesc = subty.description; 
        }
      }
    }
  }

  getInfo(data){
    this.showDetail = true;
    this.showTable = false;
    this.showCreate = false;
    this.selectedTransaction = data;

    // if (this.selectedTransaction.country_id === undefined || this.selectedTransaction.country_id === null || this.selectedTransaction.country_id === "" ) this.selectedTransaction.country_id = "No ingresado";
    // if (this.selectedTransaction.transaction_number === undefined || this.selectedTransaction.transaction_number === null || this.selectedTransaction.transaction_number === "" ) this.selectedTransaction.transaction_number = "No ingresado";
    // if (this.selectedTransaction.priority === undefined || this.selectedTransaction.priority === null || this.selectedTransaction.priority === "" ) this.selectedTransaction.subtypology_id = 10;
    // if (this.selectedTransaction.subtypology_id === undefined || this.selectedTransaction.subtypology_id === null || this.selectedTransaction.subtypology_id === "" ) this.selectedTransaction.subtypology_id = 0;
    // if (this.selectedTransaction.username === undefined || this.selectedTransaction.username === null || this.selectedTransaction.username === "" ) this.selectedTransaction.username = "No ingresado";
    // if (this.selectedTransaction.creation_date === undefined || this.selectedTransaction.creation_date === null || this.selectedTransaction.creation_date === "" ) this.selectedTransaction.creation_date = "No ingresado";
    // if (this.selectedTransaction.sponsor_id === undefined || this.selectedTransaction.sponsor_id === null || this.selectedTransaction.sponsor_id === "" ) this.selectedTransaction.sponsor_id = "No ingresado";
    // if (this.selectedTransaction.typology_id === undefined || this.selectedTransaction.typology_id === null || this.selectedTransaction.typology_id === "" ) this.selectedTransaction.typology_id = 0;
    // if (this.selectedTransaction.v_status === undefined || this.selectedTransaction.v_status === null || this.selectedTransaction.v_status === "" ) this.selectedTransaction.v_status = false;
    // if (this.selectedTransaction.id === undefined || this.selectedTransaction.id === null || this.selectedTransaction.id === "" ) this.selectedTransaction.id = 0;
    // if (this.selectedTransaction.user_id === undefined || this.selectedTransaction.user_id === null || this.selectedTransaction.user_id === "" ) this.selectedTransaction.user_id = 0;
    // //payload
    // if (this.selectedTransaction.payload.name === undefined || this.selectedTransaction.payload.name === null || this.selectedTransaction.payload.name === "" ) this.selectedTransaction.payload.name = "No ingresado";
    // if (this.selectedTransaction.payload.channel === undefined || this.selectedTransaction.payload.channel === null || this.selectedTransaction.payload.channel === "" ) this.selectedTransaction.payload.channel = "No ingresado";
    // if (this.selectedTransaction.payload.policy_number === undefined || this.selectedTransaction.payload.policy_number === null || this.selectedTransaction.payload.policy_number === "" ) this.selectedTransaction.payload.policy_number = "No ingresado";
    // if (this.selectedTransaction.payload.product === undefined || this.selectedTransaction.payload.product === null || this.selectedTransaction.payload.product === "" ) this.selectedTransaction.payload.product = "No ingresado";
    // if (this.selectedTransaction.payload.notes === undefined || this.selectedTransaction.payload.notes === null || this.selectedTransaction.payload.notes === "" ) this.selectedTransaction.payload.notes = "No ingresado";
    // if (this.selectedTransaction.payload.ammount === undefined || this.selectedTransaction.payload.ammount === null || this.selectedTransaction.payload.ammount === "" ) this.selectedTransaction.payload.ammount = "No ingresado";
    // if (this.selectedTransaction.payload.country_id === undefined || this.selectedTransaction.payload.country_id === null || this.selectedTransaction.payload.country_id === "" ) this.selectedTransaction.payload.country_id = "No ingresado";
    // if (this.selectedTransaction.payload.create_date === undefined || this.selectedTransaction.payload.create_date === null || this.selectedTransaction.payload.create_date === "" ) this.selectedTransaction.payload.create_date = "No ingresado";
    // if (this.selectedTransaction.payload.typology_id === undefined || this.selectedTransaction.payload.typology_id === null || this.selectedTransaction.payload.typology_id === "" ) this.selectedTransaction.payload.typology_id = "No ingresado";
    // if (this.selectedTransaction.payload.transaction_date === undefined || this.selectedTransaction.payload.transaction_date === null || this.selectedTransaction.payload.transaction_date === "" ) this.selectedTransaction.payload.transaction_date = "-";
    // if (this.selectedTransaction.payload.transaction === undefined || this.selectedTransaction.payload.transaction === null || this.selectedTransaction.payload.transaction === "" ) this.selectedTransaction.payload.transaction = "No ingresado";
    // if (this.selectedTransaction.payload.dni === undefined || this.selectedTransaction.payload.dni === null || this.selectedTransaction.payload.dni === "" ) this.selectedTransaction.payload.dni = "No ingresado";
    // if (this.selectedTransaction.payload.subtypology_id === undefined || this.selectedTransaction.payload.subtypology_id === null || this.selectedTransaction.payload.subtypology_id === "" ) this.selectedTransaction.payload.subtypology_id = "No ingresado";
    // if (this.selectedTransaction.payload.sponsor === undefined || this.selectedTransaction.payload.sponsor === null || this.selectedTransaction.payload.sponsor === "" ) this.selectedTransaction.payload.sponsor = "No ingresado";
    // if (this.selectedTransaction.payload.tran_type === undefined || this.selectedTransaction.payload.tran_type === null || this.selectedTransaction.payload.tran_type === "" ) this.selectedTransaction.payload.tran_type = "No ingresado";
    // if (this.selectedTransaction.payload.transaction_type === undefined || this.selectedTransaction.payload.transaction_type === null || this.selectedTransaction.payload.transaction_type === "" ) this.selectedTransaction.payload.transaction_type = "No ingresado";
    // if (this.selectedTransaction.payload.priority === undefined || this.selectedTransaction.payload.priority === null || this.selectedTransaction.payload.priority === "" ) this.selectedTransaction.payload.priority = 10;
    // if (this.selectedTransaction.payload.phone === undefined || this.selectedTransaction.payload.phone === null || this.selectedTransaction.payload.phone === "" ) this.selectedTransaction.payload.phone = "No ingresado";
    // if (this.selectedTransaction.payload.sponsor_id === undefined || this.selectedTransaction.payload.sponsor_id === null || this.selectedTransaction.payload.sponsor_id === "" ) this.selectedTransaction.payload.sponsor_id = "No ingresado";
    // if (this.selectedTransaction.payload.country === undefined || this.selectedTransaction.payload.country === null || this.selectedTransaction.payload.country === "" ) this.selectedTransaction.payload.country = "No ingresado";
  
    // let typo = this.typologies.find(t => t.id === this.selectedTransaction.typology_id);
    // let tran = this.typologies.find(tr => tr.id == this.selectedTransaction.payload.tran_type);
    // if(tran != undefined){
    //   this.selectedTransaction.tran_typeDesc = tran.description;
    // }
    // if(typo != undefined){
    //   this.selectedTransaction.typologyDesc = typo.description;

    //   if(this.selectedTransaction.subtypology_id == 0){
    //     this.selectedTransaction.subtypologyDesc == this.selectedTransaction.typologyDesc;
    //   }
    //   else{
    //     let subty = typo.subtypologies.find(st => st.id === this.selectedTransaction.subtypology_id);  
    //     if(subty != undefined){
    //       this.selectedTransaction.subtypologyDesc = subty.description; 
    //     }
    //   }
    // }
  } 

  getTypology(id){
    let result = this.typologies.find(t =>t.id == +id);
    if(result != undefined) return result.description;
    return '-';
  }
  closeTransaction(){
    if(this.closeTransactionComment.trim().length > 0){
      this.loaderService.display(true);
      let data = {transactionId: this.selectedTransaction.id, comment:  this.selectedTransaction.comment +  "  \nComentario de cierre: "+ this.closeTransactionComment}
      //codigo para cerrar gestion
      this.api.temporal_transaction_k2.close_temporal_tranasction(data).post().promise().then(data=>{
        if(data.status === 200){
          //
          this.closeTransactionComment = "";
          document.getElementById("labelError").innerHTML = "";
          this.showCloseTicketForm =false;
          this.clickShowTable2();
          this.loaderService.display(false);
          //Swal.fire('¡Realizado!', 'Transaccion '+this.selectedTransaction.transaction_number+' cerrada correctamente', 'success');
          //this.loadTransactions()
        }
        else if(data.status === 400){
          //Swal.fire('Error...', 'La transaccion '+this.closeTransactionComment+' no existe o fue eliminada', 'error');
        }
        else{
          //Swal.fire('Error', 'Ocurrió un error al intentar cerrar la transaccion, por favor intenta más tarde.', 'error');
        }
      
      }).catch(e=>{
        
        //Swal.fire('Error', 'Ocurrió un error al intentar cerrar la transaccion, por favor intenta más tarde.', 'error');
      });
    }
    else{
      document.getElementById("labelError").innerHTML = "*Debe de ingresar un valor.";
    }
  }

  dateFormat(date:Date){
    let res = null
    res = date.getDate()+'/'+(date.getMonth()+1)+'/'+date.getFullYear()+' ';
    date.getHours() > 9? res += date.getHours()+':' : res += '0'+date.getHours()+':';
    date.getMinutes() > 9? res += date.getMinutes()+':' : res += '0'+date.getMinutes()+':';
    date.getSeconds() > 9? res += date.getSeconds() : res += '0'+date.getSeconds();
    return res;
  }

  getTypologies(){
    this.api.temporalTransactions.typologies().get().promise()
      .then(data => {
        // 
        this.typologies = data.data;
        /*this.typologies = data.data
      .map(i => { return { "value": i.id, "text": i.description, "options": i.subtypologies } });*/
      })
      
      .catch(e => {
        
      })
  }

  async applyFilters() {
    if(this.filter2.hasOwnProperty("fromDate")){
      this.filter.fromDate = this.filter2.fromDate.getFullYear()+'-'+(this.filter2.fromDate.getMonth()+1)+'-'+this.filter2.fromDate.getDate();
    }
    if(this.filter2.hasOwnProperty("toDate")){
      this.filter.toDate = this.filter2.toDate.getFullYear()+'-'+(this.filter2.toDate.getMonth()+1)+'-'+this.filter2.toDate.getDate()+' '+'23:59:59.999'; 
    }
    if(this.filter.hasOwnProperty("transactionId") && (this.filter.transactionId === undefined || this.filter.transactionId.length === 0)){
      delete this.filter.transactionId;
    }
    if(this.filter.hasOwnProperty("transactionUser") && this.filter.transactionUser === undefined){
      delete this.filter.transactionUser; 
    }
    if(this.filter.hasOwnProperty("v_status") && this.filter.v_status === -1){
      delete this.filter.v_status;
    }
    if(this.filter.hasOwnProperty("v_status") && this.filter.v_status === -2){
      this.filter.v_status = undefined;
    }
    //For order 
    if(this.filter.hasOwnProperty("orderBy") && this.filter.orderBy === undefined){
      delete this.filter.orderBy;
      delete this.filter.order;
    }
    if(this.filter.hasOwnProperty("order") && this.filter.order === undefined){
      this.filter.order = "asc";
    }
    this.loaderService.display(true);
   await  this.loadtemporalTransactions();
   this.loaderService.display(false);
   this.showDialogFilter = false;
  }
  applyOrder() {
    if(this.filter.hasOwnProperty("orderBy") && this.filter.orderBy === undefined){
      delete this.filter.orderBy;
      delete this.filter.order;
    }
    if(this.filter.hasOwnProperty("order") && this.filter.order === undefined){
      this.filter.order = "asc";
    }
   // 
    this.loadtemporalTransactions();
  }

  refresh() {
    this.page = 1;
    this.filter.orderBy = 'priority';
    this.filter.order = 'desc';
    this.loadTransactions();
  }

  getSeverityClass(priority:number){
    if(priority === 30){
      return 'redpriority';
    }
    if(priority === 20){
      return 'yellowpriority';
    }
    return 'greenpriority';
  }
  getSeverityText(priority:number){
    if(priority === 30){
      return '¡Urgente!';
    }
    if(priority === 20){
      return 'Intermedio';
    }
    return 'Normal';
  }

  // changePage(event?:PageEvent):any {
  //   this.page = event.pageIndex + 1;
  //   this.loadTransactions();
  // }

  async loadCrmUsers(){
    await this.api.temporal_transaction_k2.get_admins().promise().then(data=>{
      this.crmUsers = data;
     // 
    }).catch(e =>{
     // 
    });
  }

  setRed(){
    if(this.filter.hasOwnProperty("priority") && this.filter.priority == 30){
      this.stopLightNumber = 0;
      delete this.filter.priority;
    }
    else{
      this.stopLightNumber = 30; 
      this.filter.priority = 30;
    }
  }

  setYellow(){
    if(this.filter.hasOwnProperty("priority") && this.filter.priority == 20){
      this.stopLightNumber = 0;
      delete this.filter.priority;
    }
    else{
      this.stopLightNumber = 20; 
      this.filter.priority = 20;
    }
  }

  setGreen(){
    if(this.filter.hasOwnProperty("priority") && this.filter.priority == 10){
      this.stopLightNumber = 0;
      delete this.filter.priority;
    }
    else{
      this.stopLightNumber = 10; 
      this.filter.priority = 10;
    }
  }

  getclass1(n){
    if(n==this.stopLightNumber){
        return 'btn btn-danger ml-2 bold'
    }
    else{
        return "btn btn-outline-danger ml-2"
    }
  }
  getclass2(n){
      if(n==this.stopLightNumber){
        
          return 'btn btn-warning ml-2 bold'
      }
      else{
          return "btn btn-outline-warning ml-2"
      }
  }
  getclass3(n){
      if(n==this.stopLightNumber){
        
          return 'btn btn-success ml-2 bold'
      }
      else{
          return "btn btn-outline-success ml-2"
      }
  }

  resetFilter(){
    this.filter2 = {}
    this.filter = {}
    this.filter.v_status = 10;
    this.filter.orderBy = 'priority';
    this.filter.order = 'desc';
  }

  showCloseForm(){
    this.showCloseTicketForm = true;
  }

  closeModal(){
    this.closeTransactionComment = "";
    document.getElementById("labelError").innerHTML = "";
  }

  closeModal2(){
    this.closeTransactionComment = "";
    document.getElementById("labelError").innerHTML = "";
  }

  toggleDetail(){
    if(this.showDetail){
      this.showDetail = false;
    }
    else{
      this.showDetail = true;
    }
  }
  showFilter(){
    this.showDialogFilter = true;
  }

  clickShowCreate(){
    this.showDetail = false;
    this.showTable = false;
    this.showCreate = true;
  }

  clickShowTable(){
    this.showDetail = false;
    this.showTable = true;
    this.showCreate = false;
  }

  clickShowTable2(){
    this.messageService.add({
      severity: 'info',
      summary: 'Info',
      detail: `Transacción Temporal registrada correctamente`,
    });
    this.showDetail = false;
    this.showTable = true;
    this.showCreate = false;
    this.loadTransactions()
  }

  clickShowDetail(){
    this.showDetail = true;
    this.showTable = false;
    this.showCreate = false;
  }

  
  hideFilter(){
    this.showDialogFilter = false;
  //  this.resetFilter();
  }

  // onCreatetransaction(e){
  //   
  // }

  // changePage(event:PageEvent):PageEvent {
  //   this.page = event.pageIndex + 1;
  //   this.loadTransactions();
  //   return event;
  // }

  nextPage($event) {
    this.page = $event.page + 1;
    this.loadTransactions();
  }


}
